import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Inprogress(state = initialState, action) {
  switch (action.type) {
    case userConstants.INPROGRESS_REQUEST:
      return {
        
        user: action.user,
        isLoading : true

      };
      
    case userConstants.INPROGRESS_SUCCESS:
      const {res} = action
        
      return {
        res,
        
        isLoading : false

      };
    case userConstants.INPROGRESS_FAILURE:
      return {
        
        isLoading : false
      };
    default:
      return {
        state
      }
  }
}